import { IResponseNewClass } from "components/module/addNewClass/AddNewClass.types"

export const defaultNewClassState: IResponseNewClass = {
  name: "",
  description: "",
  grade: "",
  icon: null,
  paycheck_automatic: false,
  expense_automatic: false,
  expense_interval: "",
  paycheck_interval: "",
  savings_account_option: false,
  interest_option: false,
  saving_interest_rate: "",
  round_interest_to_whole_number: false,
  interest_granting_interval: "",
  copy_settings: false,
  copy_from_id: "",
}
